import { useHistory } from 'react-router';

import MainLayout from 'packages/kakapo-ui-application/layouts/MainLayout';

import EvaluationSubmissionID from './EvaluationSubmission';
import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';
import EvaluationSubmission from 'conversations/evaluation-submission/EvaluationSubmission';

export default function EvaluationSubmissionPrint(props: { id: string }) {
	const history = useHistory();

	const readOnlyArchivedForConversationsFeature = useFeature('2024.evaluations.defaultWrite');

	const handlePrint = () => {
		// Wait until all elements are done loading
		setTimeout(() => {
			window.print();

			history.goBack();
		});
	};

	return (
		<MainLayout print>
			<style>
				{`* {
					color-adjust: exact!important;  
					-webkit-print-color-adjust: exact!important; 
					print-color-adjust: exact!important;
				}`}
			</style>
			{readOnlyArchivedForConversationsFeature ? (
				<EvaluationSubmission
					conversationID={props.id}
					isSidebarOpen={false}
					onCompleted={handlePrint}
				/>
			) : (
				<EvaluationSubmissionID id={props.id} isSidebarOpen={false} print onLoad={handlePrint} />
			)}
		</MainLayout>
	);
}
